import React, { useEffect, useState } from "react";

const Products = () => {

  const [products, setProducts] =
    useState([]);

  const [editProduct, setEditProduct] =
    useState(null);

  // =========================================
  // SEARCH + PAGINATION
  // =========================================

  const [searchTerm, setSearchTerm] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const itemsPerPage = 20;

  // =========================================
  // FETCH PRODUCTS
  // =========================================

  const fetchProducts = () => {

    fetch(
      "/api/products"
    )
      .then(res => res.json())
      .then(data => {

        if (Array.isArray(data)) {

          setProducts(data);

        } else if (
          Array.isArray(data.products)
        ) {

          setProducts(data.products);

        } else {

          setProducts([]);
        }
      });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // =========================================
  // FILTER PRODUCTS
  // =========================================

  const filteredProducts =
    products.filter(p =>

      p.name
        .toLowerCase()
        .includes(
          searchTerm.toLowerCase()
        )
    );

  // =========================================
  // PAGINATION
  // =========================================

  const indexOfLast =
    currentPage * itemsPerPage;

  const indexOfFirst =
    indexOfLast - itemsPerPage;

  const currentProducts =
    filteredProducts.slice(
      indexOfFirst,
      indexOfLast
    );

  const totalPages =
    Math.ceil(
      filteredProducts.length /
      itemsPerPage
    );

  // =========================================
  // DELETE PRODUCT
  // =========================================

  const handleDelete = async (id) => {

    if (
      !window.confirm(
        "Are you sure?"
      )
    ) return;

    try {

      const res = await fetch(

        `/api/delete-product/${id}`,

        {
          method: "DELETE"
        }
      );

      const data =
        await res.json();

      alert(data.message);

      fetchProducts();

    } catch (err) {

      console.error(err);
    }
  };

  // =========================================
  // EDIT PRODUCT
  // =========================================

  const handleEdit = (product) => {

    setEditProduct({
      ...product
    });
  };

  // =========================================
  // UPDATE PRODUCT
  // =========================================

  const handleUpdate = async () => {

    if (

      !editProduct.name ||

      editProduct.total_quantity === "" ||

      editProduct.price_per_unit === "" ||

      editProduct.rent_per_day === ""

    ) {

      alert(
        "All fields are required"
      );

      return;
    }

    if (

      editProduct.total_quantity < 0 ||

      editProduct.price_per_unit < 0 ||

      editProduct.rent_per_day < 0

    ) {

      alert(
        "Values cannot be negative"
      );

      return;
    }

    try {

      const res = await fetch(

        `/api/update-product/${editProduct.id}`,

        {
          method: "PUT",

          headers: {
            "Content-Type":
              "application/json"
          },

          body: JSON.stringify(
            editProduct
          )
        }
      );

      const data =
        await res.json();

      alert(data.message);

      fetchProducts();

      setEditProduct(null);

    } catch (err) {

      console.error(err);
    }
  };

  return (

    <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* HERO */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div>

            <p className="uppercase tracking-widest text-indigo-200 text-sm">

              Inventory Management

            </p>

            <h1 className="text-2xl md:text-4xl font-bold mt-2">

              Products

            </h1>

            <p className="mt-3 text-indigo-100">

              Manage inventory stock,
              pricing and rental availability.

            </p>

          </div>

          <div className="hidden md:flex flex-col items-end">

            <div className="bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/20">

              <p className="text-sm text-indigo-100">

                Total Products

              </p>

              <h2 className="text-4xl font-bold mt-1">

                {products.length}

              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* SEARCH + STATS */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* SEARCH */}

        <div className="col-span-1 lg:col-span-8 bg-white rounded-3xl p-5 shadow-sm border border-gray-100">

          <div className="flex items-center gap-4">

            <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center text-xl">

              🔍

            </div>

            <input
              type="text"
              placeholder="Search product..."
              value={searchTerm}
              onChange={(e) => {

                setSearchTerm(
                  e.target.value
                );

                setCurrentPage(1);
              }}
              className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
            />

          </div>

        </div>

        {/* STATS */}

        <div className="col-span-1 lg:col-span-4 bg-white rounded-3xl p-5 md:p-6 shadow-sm border border-gray-100">

          <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

            <div>

              <p className="text-sm text-gray-500">

                Filtered Products

              </p>

              <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mt-3">

                {filteredProducts.length}

              </h2>

            </div>

            <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-3xl">

              📦

            </div>

          </div>

        </div>

      </div>

      {/* PRODUCT TABLE */}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">

        {/* HEADER */}

        <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">

              Product Inventory

            </h2>

            <p className="text-sm text-gray-500 mt-1">

              Inventory stock and rental availability

            </p>

          </div>

          <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

            Inventory List

          </div>

        </div>

        {/* TABLE */}

        <div className="overflow-x-auto">

          <table className="min-w-[850px] w-full">

            <thead className="bg-gray-50 text-gray-500 text-sm">

              <tr>

                <th className="text-left px-8 py-5">
                  Product
                </th>

                <th className="text-left px-6 py-5">
                  Total
                </th>

                <th className="text-left px-6 py-5">
                  Available
                </th>

                <th className="text-left px-6 py-5">
                  Rented
                </th>

                <th className="text-left px-6 py-5">
                  Lost
                </th>

                <th className="text-left px-6 py-5">
                  Price
                </th>

                <th className="text-left px-6 py-5">
                  Rent / Day
                </th>

                <th className="text-right px-8 py-5">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {currentProducts.length === 0 ? (

                <tr>

                  <td
                    colSpan="8"
                    className="py-20 text-center text-gray-500"
                  >

                    No products found

                  </td>

                </tr>

              ) : (

                currentProducts.map((p) => (

                  <tr
                    key={p.id}
                    className="border-t border-gray-100 hover:bg-gray-50 transition"
                  >

                    {/* PRODUCT */}

                    <td className="px-8 py-6">

                      <div className="flex items-center gap-4">

                        <div className="w-12 h-12 rounded-2xl bg-indigo-100 flex items-center justify-center font-bold text-indigo-600">

                          {p.name?.charAt(0)}

                        </div>

                        <div>

                          <p className="font-semibold text-gray-800 text-base">

                            {p.name}

                          </p>

                          <p className="text-sm text-gray-500 mt-1">

                            Rental Product

                          </p>

                        </div>

                      </div>

                    </td>

                    {/* TOTAL */}

                    <td className="px-6 py-6 font-medium text-gray-700">

                      {p.total_quantity}

                    </td>

                    {/* AVAILABLE */}

                    <td className="px-6 py-6">

                      <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">

                        {
                          p.available_quantity
                        }

                      </span>

                    </td>

                    {/* RENTED */}

                    <td className="px-6 py-6">

                      <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-semibold">

                        {

                          p.total_quantity

                          -

                          p.available_quantity

                          -

                          Number(
                            p.lost_quantity || 0
                          )

                        }

                      </span>

                    </td>

                    {/* LOST */}

                    <td className="px-6 py-6">

                      <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-xs font-semibold">

                        {p.lost_quantity || 0}

                      </span>

                    </td>

                    {/* PRICE */}

                    <td className="px-6 py-6 font-semibold text-gray-700">

                      ₹{p.price_per_unit}

                    </td>

                    {/* RENT */}

                    <td className="px-6 py-6 font-semibold text-indigo-600">

                      ₹{p.rent_per_day}

                    </td>

                    {/* ACTIONS */}

                    <td className="px-8 py-6 text-right whitespace-nowrap space-x-3">

                      <button
                        onClick={() =>
                          handleEdit(p)
                        }
                        className="whitespace-nowrap border border-gray-200 hover:bg-gray-100 px-5 py-3 rounded-2xl font-medium transition"
                      >

                        Edit

                      </button>

                      <button
                        onClick={() =>
                          handleDelete(p.id)
                        }
                        className="whitespace-nowrap bg-red-500 hover:bg-red-600 text-white px-5 py-3 rounded-2xl font-medium transition"
                      >

                        Delete

                      </button>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

        {/* PAGINATION */}

        <div className="px-5 md:px-8 py-5 border-t border-gray-100 flex flex-col md:flex-row justify-between md:items-center gap-4">

          <p className="text-sm text-gray-500">

            Showing
            {" "}

            <span className="font-semibold text-gray-700">

              {

                filteredProducts.length === 0

                  ? 0

                  : indexOfFirst + 1
              }

            </span>

            {" "}
            to
            {" "}

            <span className="font-semibold text-gray-700">

              {
                Math.min(
                  indexOfLast,
                  filteredProducts.length
                )
              }

            </span>

            {" "}
            of
            {" "}

            <span className="font-semibold text-gray-700">

              {filteredProducts.length}

            </span>

            {" "}
            products

          </p>

          {/* BUTTONS */}

          <div className="flex gap-2 flex-wrap">

            <button
              onClick={() =>

                setCurrentPage(prev =>

                  Math.max(
                    prev - 1,
                    1
                  )
                )
              }
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm hover:bg-gray-100 transition"
            >

              Prev

            </button>

            {[...Array(totalPages)].map(
              (_, i) => (

                <button
                  key={i}
                  onClick={() =>
                    setCurrentPage(i + 1)
                  }
                  className={`px-4 py-2 text-sm rounded-xl transition

                    ${
                      currentPage === i + 1

                        ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow"

                        : "border border-gray-200 hover:bg-gray-100"
                    }
                  `}
                >

                  {i + 1}

                </button>

              )
            )}

            <button
              onClick={() =>

                setCurrentPage(prev =>

                  Math.min(
                    prev + 1,
                    totalPages
                  )
                )
              }
              className="px-4 py-2 border border-gray-200 rounded-xl text-sm hover:bg-gray-100 transition"
            >

              Next

            </button>

          </div>

        </div>

      </div>

      {/* EDIT MODAL */}

      {editProduct && (

        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-6">

          <div className="bg-white rounded-3xl shadow-xl w-full max-w-lg overflow-hidden">

            {/* HEADER */}

            <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

              <div>

                <h2 className="text-2xl font-bold text-gray-800">

                  Edit Product

                </h2>

                <p className="text-sm text-gray-500 mt-1">

                  Update inventory details

                </p>

              </div>

              <button
                onClick={() =>
                  setEditProduct(null)
                }
                className="w-10 h-10 rounded-xl hover:bg-gray-100 transition"
              >

                ✕

              </button>

            </div>

            {/* BODY */}

            <div className="p-5 md:p-8 space-y-5">

              <div>

                <label className="block text-sm font-medium text-gray-600 mb-2">

                  Product Name

                </label>

                <input
                  type="text"
                  value={editProduct.name}
                  onChange={(e) =>

                    setEditProduct({

                      ...editProduct,

                      name:
                        e.target.value
                    })
                  }
                  className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-5 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
                />

              </div>

             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                <div>

                  <label className="block text-sm font-medium text-gray-600 mb-2">

                    Total

                  </label>

                  <input
                    type="number"
                    value={
                      editProduct.total_quantity
                    }
                    onChange={(e) =>

                      setEditProduct({

                        ...editProduct,

                        total_quantity:
                          Number(
                            e.target.value
                          )
                      })
                    }
                    className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-4 py-4 outline-none focus:ring-2 focus:ring-indigo-500"
                  />

                </div>

                <div>

                  <label className="block text-sm font-medium text-gray-600 mb-2">

                    Price

                  </label>

                  <input
                    type="number"
                    value={
                      editProduct.price_per_unit
                    }
                    onChange={(e) =>

                      setEditProduct({

                        ...editProduct,

                        price_per_unit:
                          Number(
                            e.target.value
                          )
                      })
                    }
                    className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-4 py-4 outline-none focus:ring-2 focus:ring-emerald-500"
                  />

                </div>

                <div>

                  <label className="block text-sm font-medium text-gray-600 mb-2">

                    Rent / Day

                  </label>

                  <input
                    type="number"
                    value={
                      editProduct.rent_per_day
                    }
                    onChange={(e) =>

                      setEditProduct({

                        ...editProduct,

                        rent_per_day:
                          Number(
                            e.target.value
                          )
                      })
                    }
                    className="w-full border border-gray-200 bg-gray-50 rounded-2xl px-4 py-4 outline-none focus:ring-2 focus:ring-orange-500"
                  />

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="px-5 md:px-8 py-5 border-t border-gray-100 flex flex-col sm:flex-row justify-end gap-4">

              <button
                onClick={() =>
                  setEditProduct(null)
                }
                className="w-full sm:w-auto px-6 py-3 border border-gray-200 rounded-2xl hover:bg-gray-100 transition"
              >

                Cancel

              </button>

              <button
                onClick={handleUpdate}
                className="w-full sm:w-auto bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-3 rounded-2xl font-semibold hover:shadow-lg transition"
              >

                Update Product

              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default Products;